//import Axios from "axios";

import api from "../../api";
import {
  PRODUCT_DETAIL_FAIL,
  PRODUCT_DETAIL_REQUEST,
  PRODUCT_LIST_FAIL,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
} from "../constant/productConstant";

export const listProducts = (category = "") => async (dispatch) => {

  dispatch({
    type: PRODUCT_LIST_REQUEST,
  });

  try {

    const url = category ? `/products/category/${category}` : `/products`;
    const { data } = await api.get(url);
    dispatch({
      type: PRODUCT_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_LIST_FAIL,
      payload: error.message,
    });
  }
};

export const detailProduct =
  ({ id }) =>
    async (dispatch) => {

      dispatch({ type: PRODUCT_DETAIL_REQUEST, payload: { id } });
      try {

        // const { data } = await api.get(`/products/${id}`);
        const url = id ? `/products/${id}` : `/products`;
        //const { data } = await api.get(`/products/category/${category}/${id}`);
        const { data } = await api.get(url);
        console.log("data:", data)
        dispatch({ type: PRODUCT_LIST_SUCCESS, payload: data });
      } catch (error) {
        dispatch({
          type: PRODUCT_DETAIL_FAIL,
          payload:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        });
      }
    };
